import { AxiosRequestConfig } from "axios";
import {
    BEARER,
    X_AUTH_LENDSMART_NAMESPACE,
    X_AUTH_LENDSMART_EMAIL,
    AuthConfig,
    Authenticator
} from './auth'
import { defaultTo, equals, flatten, join, map, trim } from "ramda";
import { authenticatedUser, authentication } from "src/utilities/storage";
import { getNamespaceName } from "../objects/namespaces";
import { isNotEmpty } from "src/utilities/hasValue";


class BearerUserAuthenticator implements Authenticator {

    auth: AuthConfig;

    constructor(auth: AuthConfig) {
        this.auth = auth;
    }

    private base64Headers(
        accountId: string,
        accountEmail: string,
        sessionToken: string,
        roles: string[] = []
    ) {
        const defaultToEmpty = defaultTo('');
        const data = {
            email: defaultToEmpty(accountEmail),
            token: defaultToEmpty(sessionToken),
            roles: join(',', map(trim, flatten([roles]))),
            account_id: defaultToEmpty(accountId).toString(),
        }
        return window.btoa(JSON.stringify(data));

    };

    private generateToken() {
        const roles = authenticatedUser.rolesId.get()
        return this.base64Headers(
            authenticatedUser.accountId.get(),
            authenticatedUser.accountEmail.get(),
            authentication.token.get(),
            isNotEmpty(roles) ? JSON.parse(`${roles}`): []
        )
    }

    public isAuthProvider(): boolean {
        return equals(this.auth.provider, BEARER)
    }

    public applyAuthentication(config: AxiosRequestConfig): AxiosRequestConfig {
        return {
            ...config,
            headers: {
                ...config.headers,
                ...(authenticatedUser.accountEmail.get() && {
                    Content: 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${this.generateToken()}`,
                    [X_AUTH_LENDSMART_NAMESPACE]: getNamespaceName(),
                    [X_AUTH_LENDSMART_EMAIL]: authenticatedUser.accountEmail.get() || '',
                    'Access-Control-Allow-Origin': '*',
                }),
                responseType: 'json'
            },
        };
    }

    public shouldRefresh() {
        return false
    }

    public refreshAuthentication() {
        // Update session with latest token 
        return Promise.resolve()
    }
};

export {
    BearerUserAuthenticator
};